"use strict";

module.exports.NavBarConfig = {
  structure: [
    {
      id: "Start",
      link: "/"
    },
    {
      id: "Über uns",
      link: "/ueber-uns",
      sub: [
        { id: "Ausstellung", name: "Ausstellung" },
        { id: "Unser Team", name: "Unser Team" },
        { id: "Unsere Werkstatt", name: "Unsere Werkstatt" }
      ]
    },
    {
      id: "Service",
      link: "/service"
    },
    {
      id: "Leistungen",
      link: "/leistungen/ueberblick",
      sub: [
        { id: "Küchenarbeitsplatten", name: "Küchenarbeitsplatten" },
        { id: "Böden", name: "Böden" },
        { id: "Treppen", name: "Treppen" },
        { id: "Waschtische & Bäder", name: "Bäder" },
        { id: "Fensterbänke", name: "Fensterbänke" },
        { id: "Tische & Theken", name: "TischeTheken" },
        { id: "Eingangsbereiche", name: "Eingangsbereich" },
        { id: "Individuelle Produkte", name: "IndividuelleProdukte" }
      ]
    },
    {
      id: "Materialien",
      link: "/material/natursteine-und-kunststeine",
      sub: [
        { id: "Materialsuche", name: "Materialsuche" },
        { id: "Weichgesteine", name: "Weichgesteine" },
        { id: "Hartgesteine", name: "Hartgesteine" },
        { id: "Quarzkomposit", name: "Quarzkomposit" },
        { id: "Keramik", name: "Keramik" }
      ]
    },
    {
      id: "Referenzen",
      link: "/referenzen"
    },
    {
      id: "Kontakt",
      link: "/kontakt"
    }
  ]
};



// WEBPACK FOOTER //
// ./src/config/navbar.config.js